export const DEFAULT_OFFICIAL_INSTANCE_PROVIDER = 'dialog';
export const officialInstanceProviders = Object.freeze([
  {
    label: 'Dialog',
    value: 'dialog'
  },
  {
    label: 'Vonage',
    value: 'vonage'
  },
  {
    label: 'Messenger',
    value: 'messenger'
  },
  {
    label: 'Instagram',
    value: 'instagram'
  },
  {
    label: 'YCloud',
    value: 'ycloud'
  }
]);

export const getOfficialProviderValueByIntegrationId = (integrationId) => {
  const providersByIntegrationId = {
    1: 'dialog',
    2: 'vonage',
    3: 'messenger',
    4: 'instagram',
    5: 'ycloud'
  };

  return providersByIntegrationId[integrationId] || DEFAULT_OFFICIAL_INSTANCE_PROVIDER;
};

export const getOfficialProviderLabel = (providerValue) => {
  const provider = officialInstanceProviders.find(({ value }) => value === providerValue);

  return provider ? provider.label : 'Dialog';
};